import React from 'react';

function Dashboard() {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
      <p className="mt-4">Welcome to the Koala CRM Dashboard (to be expanded).</p>
    </div>
  );
}

export default Dashboard;